export const PaymentHistoryTestIds = {
  // PaymentHistory.js
  RECORD_BUTTON: 'payment-history.record-button',

  // PaymentDrawerContent.js
  DUE_DATE_SELECT: 'payment-form.due-date-select',
  PAYMENT_DATE: 'payment-form.payment-date',
  EFFECTIVE_DATE: 'payment-form.effective-date',
  METHOD_SELECT: 'payment-form.method-select',
  STATUS_SELECT: 'payment-form.status-select',
  REFERENCE_NUMBER_INPUT: 'payment-form.reference-number-input',
  NOTES_INPUT: 'payment-form.notes-input',
};
